import type { ReactNode } from 'react'
import { Text as ChakraText, type TextProps as ChakraTextProps } from '@chakra-ui/react'
import { useTranslator } from './I18nContext'

export interface TextProps extends Omit<ChakraTextProps, 'children'> {
  /** Translation key. If provided, resolves via the i18n context. */
  tid?: string
  /** Interpolation values for the translation. */
  values?: Record<string, unknown>
  children?: ReactNode
}

/**
 * Drop-in replacement for Chakra `<Text>` with an optional `tid` prop.
 *
 * - If `tid` is provided, it resolves the key through the i18n context.
 * - Otherwise, renders `children` exactly like Chakra's `Text`.
 *
 * Exported as both `Text` (preferred) and `T` (legacy alias).
 */
export function Text({ tid, values, children, ...textProps }: TextProps) {
  const t = useTranslator()
  const content = tid ? t(tid, values) : children
  return <ChakraText {...textProps}>{content}</ChakraText>
}

export const T = Text
export type TProps = TextProps
